import React from 'react';
import { motion } from 'framer-motion';
const FIELD_NOTES = [{
  id: 1,
  title: 'A week at the Sloan Sports Analytics Conference',
  date: 'Oct 25',
  readTime: '4 min'
}, {
  id: 2,
  title: 'Three things about the new NBA media rights deal nobody is saying out loud',
  date: 'Oct 23',
  readTime: '3 min'
}, {
  id: 3,
  title: 'What the new MLB jersey patches tell you about the next decade',
  date: 'Oct 21',
  readTime: '5 min'
}, {
  id: 4,
  title: 'On the strange new respectability of sportsbook advertising',
  date: 'Oct 18',
  readTime: '6 min'
}, {
  id: 5,
  title: 'Reading the room: what GMs are actually scared of right now',
  date: 'Oct 15',
  readTime: '4 min'
}, {
  id: 6,
  title: 'The front office is back and nobody told the agents',
  date: 'Oct 12',
  readTime: '3 min'
}];
export function FieldNotes() {
  return <section id="field-notes" className="bg-accent-dark text-cream py-20 lg:py-28 border-thick-b" data-id="element-53">
      <div className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 lg:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6" data-id="element-55">
          <div data-id="element-56">
            <span className="kicker-block-inverse text-sm mb-8" data-id="element-57">
              Shorter dispatches
            </span>
            <h2 className="font-serif text-7xl sm:text-8xl lg:text-9xl xl:text-[11rem] font-black tracking-tighter leading-[0.85] uppercase mt-8" data-id="element-58">
              Field
              <br data-id="element-59" />
              Notes
            </h2>
          </div>
          <p className="font-sans text-xl sm:text-2xl font-bold text-cream/80 leading-snug max-w-md" data-id="element-60">
            Quick observations, half-formed arguments, and dispatches from
            inside the business of sports. Read in 5 minutes.
          </p>
        </motion.div>

        {/* Two-column dense list */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 border-t-4 border-cream" data-id="element-61">
          {FIELD_NOTES.map((note, index) => <motion.a key={note.id} href="#" initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="group flex items-baseline gap-6 py-8 border-b-4 border-cream/20 hover:border-cream transition-colors cursor-pointer" data-id="element-62">
              <span className="font-mono text-sm font-black tracking-widest uppercase text-cream/50 shrink-0 w-20 pt-1" data-id="element-63">
                {note.date}
              </span>
              <div className="flex-grow" data-id="element-64">
                <h3 className="font-serif text-2xl sm:text-3xl font-black leading-[0.95] group-hover:text-cream transition-colors tracking-tight mb-2 text-cream/90" data-id="element-65">
                  {note.title}
                </h3>
                <span className="font-mono text-xs font-bold tracking-widest uppercase text-cream/40" data-id="element-66">
                  {note.readTime} read
                </span>
              </div>
            </motion.a>)}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center" data-id="element-67">
          <a href="#" className="inline-flex items-center space-x-3 font-mono text-base font-black uppercase tracking-widest text-cream hover:text-cream/70 transition-colors group border-b-4 border-cream hover:border-cream/70 pb-1" data-id="element-68">
            <span data-id="element-69">All Field Notes</span>
            <span className="transform transition-transform group-hover:translate-x-2" data-id="element-70">
              →
            </span>
          </a>
        </div>
      </div>
    </section>;
}